import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ya-errorvalidation',
  templateUrl: './errorValidation.component.html',
  styleUrls: ['./errorValidation.component.scss']
})
export class ErrorValidationComponent implements OnInit {

  @Input() controlValidation: boolean;
  @Input() errorMessage: string;

  constructor() { }

  ngOnInit() {
    const me = this;
  }

}
